"use client"

import { Slack } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SlackIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SlackIcon = component(Icon)({ as: Slack })
